import { render } from "./SpecialPrice.vue?vue&type=template&id=f5faf94c&scoped=true"
import script from "./SpecialPrice.vue?vue&type=script&lang=js"
export * from "./SpecialPrice.vue?vue&type=script&lang=js"

import "./SpecialPrice.vue?vue&type=style&index=0&id=f5faf94c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5faf94c"]])

export default __exports__